import { render, staticRenderFns } from "./ArtworkModal.vue?vue&type=template&id=004f5be2&scoped=true"
import script from "./ArtworkModal.vue?vue&type=script&lang=js"
export * from "./ArtworkModal.vue?vue&type=script&lang=js"
import style0 from "./ArtworkModal.vue?vue&type=style&index=0&id=004f5be2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f5be2",
  null
  
)

export default component.exports